import {ip_back , api_key} from '../constants/appConstants';

const API_URL = ip_back + '/api/siniestros';


export const crearSiniestro = async (formData, poliza, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "poliza" : poliza, "monto" : formData.monto,  "deducible": formData.deducible, "rasa": formData.rasa, "indemnizacion" : formData.indemnizacion, "observaciones" : formData.observaciones, "creador" : creador, "fecha" : formData.fecha}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const cargarSiniestros = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/listar?poliza=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error('Error al cargar siniestros');
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const obtenerSiniestro = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/obtener?id=${id}`, {        
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error(`Error al obtener el siniestro: ${id}`);
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const eliminarSiniestro = async (id, editor) => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${API_URL}/eliminar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "id" : id, "editor" : editor}),
        });
          return response;
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
};

export const actualizarSiniestro = async (formData, editor, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "id" : id, "monto" : formData.monto,  "deducible": formData.deducible, "rasa": formData.rasa, "indemnizacion" : formData.indemnizacion, "observaciones" : formData.observaciones, "editor" : editor, "fecha" : formData.fecha}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const listarDocumentos = async (id) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/listarDocumentos?siniestro=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) {
        if (response.status === 404) {
          return [];
        }
      }
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const eliminarDocumento = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminarDocumento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const agregarDocumento = async (formData, siniestro, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/subirDocumento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "creador": creador, "tipo": formData.tipo, "extension": formData.extension, "nombre": formData.nombre, "contenido": formData.contenido, "siniestro": siniestro }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarDocumento = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizarDocumento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "editor": editor, "id": formData.id, "extension": formData.extension, "nombre": formData.nombre, "contenido": formData.contenido }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};